import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

export const onRouteUpdate = () => {
    if (typeof document !== "undefined") {
        const elements = document.querySelectorAll(".fadeInUp");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("on");
                    }
                });
            },
            { threshold: 0.1 }
        );

        elements.forEach((el) => observer.observe(el));

        return () => {
            elements.forEach((el) => observer.unobserve(el));
        };
    }
};

export const onClientEntry = () => {
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("js");
  }
};






// import "@fontsource/noto-sans-jp";
// import "./src/styles/base.css";
// import "./src/styles/blog-contents-style.css";

// // ファイルの先頭で一度だけ読み込む
// let LocomotiveScroll;
// if (typeof window !== "undefined") {
//   LocomotiveScroll = require("locomotive-scroll").default;
// }

// export const onRouteUpdate = () => {
//   if (typeof window === "undefined" || !LocomotiveScroll) return;

//   // 既存インスタンスがあれば破棄
//   if (window.scrollInstance) {
//     window.scrollInstance.destroy();
//   }

//   // Locomotive Scroll 初期化
//   window.scrollInstance = new LocomotiveScroll({
//     el: document.querySelector("[data-scroll-container]"),
//     smooth: true,
//     lerp: 0.08,
//     smoothMobile: true,
//     multiplier: 1.0,
//   });

//   // fadeInUp 要素の監視
//   const fadeElements = document.querySelectorAll(".fadeInUp");
//   const checkFadeElements = () => {
//     fadeElements.forEach((el) => {
//       const rect = el.getBoundingClientRect();
//       if (rect.top < window.innerHeight * 0.9) el.classList.add("on");
//     });
//   };
//   checkFadeElements();
//   window.scrollInstance.on("scroll", checkFadeElements);

//   // ページロード後にアップデート
//   window.addEventListener("load", () => {
//     window.scrollInstance?.update();
//   });

//   // 500ms 後にもアップデート（Vanta.js など読み込み完了後の調整）
//   setTimeout(() => {
//     window.scrollInstance?.update();
//   }, 500);
// };
